import { useNifValidationError } from "./useNifValidation";

export function useShowDeudaFilters(queryFilters: any) {
    const errorDni = useNifValidationError(queryFilters.nif);
    return queryFilters.nif.length>0 && queryFilters.deudaType.length>0 && !errorDni;
}